module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("For George W. Smalley (1930-2003) and for the students of Lawrence University who\n\t\t\t\t\tthumbed Skippy, ogled onion domes, and, laughing, set up tents in the rain on the\n\t\t\t\t\t“Slavic Trips,” 1969 to 1991.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0